import { IconFont, BasTitle, UpLoadFile, SvgIcon } from '@/components'
import { Message } from '@/components/message'
import { Button, Modal, Typography, Form, Radio } from 'antd'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useUploadMailLog } from '@/pages/email/task-detail/utils'
import { t } from '@/i18n'

interface PropsType {
  open: boolean
  type: string // ES (终端安全) TS(流量安全) WS(web安全)
  onClose: () => void
  resultId: string | undefined
  refreshPage: () => void
  options: {
    label: string
    value: string
    disabled: boolean
  }[]
  deviceTypeValue: string
}

export const ImportModal: React.FC<PropsType> = ({
  open,
  type,
  resultId,
  onClose,
  refreshPage,
  deviceTypeValue = 'WAF',
  options = [],
}) => {
  const [uploadSuccess, setUploadSuccess] = useState(false)
  const [uploadXlsxLoading, setUploadXlsxLoading] = useState(false)
  const [actionApi, setActionApi] = useState('')
  const [step, setStep] = useState(1)
  const [deviceType, setDeviceType] = useState<
    'WAF' | 'NTA' | 'IDS' | 'IPS' | 'MS' | 'AC' | 'TIP' | '容器安全'
  >(deviceTypeValue)
  const [logType, setLogType] = useState<'Excel' | 'Zip'>('Excel')
  const [uploadMailLog] = useUploadMailLog()
  const [form] = Form.useForm()
  useEffect(() => {
    if (open) {
      if (type === 'ES') {
        setActionApi(`/portal/v1/endpoint_security/results/${resultId}/import_offline_log`)
      } else if (type === 'TS') {
        setActionApi(`/portal/v1/tp/results/${resultId}/import_offline_log`)
      } else if (type === 'MS') {
        setActionApi(`/portal/oss/upload`)
        setDeviceType('MS')
      } else if (type === 'WG') {
        setActionApi(`/portal/v1/wg/results/${resultId}/import_offline_log`)
      } else if (type === 'CS') {
        setActionApi(`/portal/v1/container_security/results/${resultId}/import_offline_log`)
      } else {
        setActionApi(`/portal/v1/waf/results/${resultId}/import_offline_log`)
      }
    }
  }, [open])

  useEffect(() => {
    if (deviceTypeValue) {
      form.setFieldsValue({
        deviceType: deviceTypeValue,
      })
    }
  }, [deviceTypeValue])

  return (
    <ModalBox
      width={600}
      title={
        <BasTitle
          title={
            step === 1
              ? t('离线日志导入')
              : !uploadSuccess
              ? t('离线日志导入')
              : t('离线日志导入结果')
          }
        />
      }
      open={open}
      centered
      onCancel={() => {
        onClose()
        setUploadSuccess(false)
        setStep(1)
      }}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          {step === 1 ? (
            <Button type="primary" onClick={() => setStep(2)}>
              {t('下一步')}
            </Button>
          ) : (
            <>
              <Button
                onClick={() => {
                  onClose()
                  setUploadSuccess(false)
                  setStep(1)
                }}
              >
                {t('取消')}
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  onClose()
                  setUploadSuccess(false)
                  setStep(1)
                }}
                disabled={!uploadSuccess}
              >
                {t('提交')}
              </Button>
            </>
          )}
        </div>
      }
    >
      <div className="step-box">
        <div className="step-item">
          <SvgIcon name="类型确认" width={44} height={44} />
          <span className="step-text active">{t('类型确认')}</span>
        </div>
        <div className="arrow">
          <SvgIcon
            width="40"
            height="40"
            name={step === 1 ? 'step-arrow-normal' : 'step-arrow-active'}
          />
        </div>
        <div className="step-item">
          <SvgIcon name={step === 2 ? '上传日志' : '上传日志灰'} width={44} height={44} />
          <span className={step === 2 ? 'step-text active' : 'step-text'}>{t('上传日志')}</span>
        </div>
      </div>
      {step === 1 && (
        <Form layout="horizontal" labelCol={{ flex: '80px' }} wrapperCol={{ flex: 1 }}>
          <Form.Item
            label={
              <span>
                <span style={{ color: 'red' }}>*</span> {t('设备类型')}
              </span>
            }
            style={{ marginBottom: 24, alignItems: 'center', display: 'flex' }}
            colon={false}
          >
            <Radio.Group
              value={deviceType}
              onChange={e => setDeviceType(e.target.value)}
              style={{ display: 'flex', gap: 32 }}
            >
              {options.map(item => (
                <Radio value={item.value} disabled={item?.disabled}>
                  {item.label}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label={
              <span>
                <span style={{ color: 'red' }}>*</span> {t('日志类型')}
              </span>
            }
            style={{ marginBottom: 24, alignItems: 'center', display: 'flex' }}
            colon={false}
          >
            <Radio.Group
              value={logType}
              onChange={e => setLogType(e.target.value)}
              style={{ display: 'flex', gap: 32 }}
            >
              <Radio value="Excel">Excel</Radio>
              <Radio value="Zip" disabled>
                .zip（json）
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      )}
      {step === 2 &&
        (uploadSuccess ? (
          <ResultContainer>
            <IconFont type={'icon-chenggong2'} className="icon" />
            <div className="result" style={{ margin: '40px 0' }}>
              {t('导入成功')}
            </div>
          </ResultContainer>
        ) : (
          <>
            <UpLoadFile
              uploadXlsxLoading={uploadXlsxLoading}
              showUploadList={false}
              disabled={uploadXlsxLoading}
              headers={{
                'user-id': JSON.parse(localStorage.getItem('token') as string)?.id,
                token: JSON.parse(localStorage.getItem('token') as string)?.token,
              }}
              data={{
                device_type: deviceType,
                log_type: logType,
                result_id: resultId,
              }}
              action={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${actionApi}`}
              beforeUpload={file => {
                const reg = /\.xlsx$/
                const maxSize = 20 * 1024 * 1024
                if (reg.test(file.name)) {
                  if (file.size > maxSize) {
                    Message.error(t('导入失败，文件大小超出上限'))
                    return false
                  }
                  return true
                }
                Message.error(t('导入失败，文件格式错误，请上传Excel格式文件 '))
                return false
              }}
              progress={{
                strokeColor: {
                  '0%': '#108ee9',
                  '100%': '#87d068',
                },
                strokeWidth: 3,
                format: percent => percent && `${parseFloat(percent.toFixed(2))}%`,
              }}
              onChange={({ file }) => {
                if (file.status === 'uploading') {
                  setUploadXlsxLoading(true)
                  return
                }

                if (
                  file.status === 'done' ||
                  file.status === 'error' ||
                  file.status === 'removed' ||
                  file.status === 'success'
                ) {
                  setUploadXlsxLoading(false)
                }
                if (file.status === 'done') {
                  console.log('file.response', file.response)
                  const { code, msg, data } = file.response
                  if (code === 200) {
                    if (type === 'ES') {
                      setUploadSuccess(true)
                      refreshPage()
                    } else if (type === 'TS') {
                      setUploadSuccess(true)
                      refreshPage()
                    } else if (type === 'MS') {
                      uploadMailLog({
                        fileId: data.file_id,
                        device_type: deviceType,
                        log_type: logType,
                        resultId: resultId,
                      }).then(res => {
                        setUploadSuccess(true)
                        refreshPage()
                      })
                    } else {
                      setUploadSuccess(true)
                      refreshPage()
                    }
                  } else {
                    Message.error(msg || t('导入失败，不符合导入要求'))
                  }
                  return
                }

                if (file.status === 'error') {
                  Message.error(t('上传失败'))
                }
              }}
              name={'file'}
              maxCount={1}
              text={
                uploadXlsxLoading ? (
                  t('上传中,请稍后')
                ) : (
                  <div>
                    <div style={{ color: '#666666', marginBottom: '12px' }}>
                      {t('将文件拖拽到此处，或')}
                      <Typography.Link
                        style={{ color: '#4238c9', borderBottom: '1px solid #4238c9' }}
                      >
                        {t('点击上传')}
                      </Typography.Link>
                    </div>
                    <div style={{ color: '#666666', fontSize: '12px' }}>
                      {t('支持上传Excel格式，文件不超过20M')}
                    </div>
                  </div>
                )
              }
            />

            <Typography.Link
              target="_blank"
              style={{
                display: 'inline-block',
                marginTop: '24px',
                color: '#031A79',
                marginRight: '20px',
              }}
              href={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${
                type === 'ES'
                  ? '/static/endpoint-security/endpoint-security-offline-log.xlsx'
                  : type === 'TS'
                  ? '/static/threat-protection/threat-protection-offline-log.xlsx'
                  : type === 'MS'
                  ? '/static/email-gateway/eg-offline-log.xlsx'
                  : type === 'WG'
                  ? '/static/web-gateway/web-gateway-offline-log.xlsx'
                  : type === 'CS'
                  ? '/static/container-security/container-security-offline-log.xlsx'
                  : '/static/waf/waf-offline-log.xlsx'
              }`}
            >
              <IconFont type="icon-xiazaimoban" style={{ color: '#031A79', marginRight: '4px' }} />
              {t('常规类设备模板')}
            </Typography.Link>
          </>
        ))}
    </ModalBox>
  )
}

const ModalBox = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
    }
  }
  .step-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    .step-item {
      display: flex;
      align-items: center;
      .step-text {
        margin-left: 10px;
        color: #999999;
        font-size: 14px;
        &.active {
          color: #333333;
        }
      }
    }
    .arrow {
      margin: 0 16px;
    }
  }
`

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  .icon {
    font-size: 54px;
  }
  .result {
    margin: 5px 0;
    margin-top: 10px;
    font-size: 24px;
  }
  .text {
    color: #666;
    line-height: 1.2;
  }
  .content-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .content {
    width: 168px;
    height: 152px;
    background: #f7f8f9;
    border-radius: 8px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    div {
      margin-bottom: 12px;
    }
  }
  .num {
    font-weight: bold;
    font-size: 18px;
    color: #558492;
  }
  .num-err {
    font-weight: bold;
    font-size: 18px;
    color: #f53f3f;
  }
`
